import { useQuery } from 'react-query';
import { users } from '../../../API/TT_ELD/Users/user';
import { TableParams } from '../../../Utils/TableTypes';

export const useUsersData = (
  companyId: undefined | string,
  role: undefined | string,
  status: string | undefined,
  driverName: any,
  driverEmail: undefined | string,
  userName?: undefined | string,
  licenseNumber?: undefined | string | number,
  uid?: string,
  companyUID?: string,
  tableParams?: TableParams,
) => {
  return useQuery(
    [
      `users/${driverName || 'all'}`,
      companyId,
      role,
      status,
      driverName,
      driverEmail,
      userName,
      licenseNumber,
      uid,
      companyUID,
      tableParams,
    ],
    () =>
      users.read(
        companyId,
        role,
        status,
        driverName,
        driverEmail,
        userName,
        licenseNumber,
        uid,
        companyUID,
        tableParams,
      ),
    { refetchOnWindowFocus: false },
  );
};

export const useUserData = (userId: number | string | undefined) => {
  return useQuery([`users/${userId}`, userId], () => users.userData(userId), {
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
  });
};

export const useTrackingRang = (
  skip: string | number,
  date: string | number | any,
  driverId: string | undefined,
) => {
  return useQuery(
    [`admin/report${skip || 'all'}`, skip, date, driverId],
    () => users.trackingByRang(skip, date, driverId),
    { refetchOnWindowFocus: false },
  );
};
